import { AnyNode } from "domhandler";
import { ProcessingInstruction, ProcessNodeDefinitions } from "html-to-react";

export type HtmlToReactProcessor = (
  node: AnyNode,
  children: JSX.Element[],
  index: number,
  defaultProcessor: () => JSX.Element | false,
  language?: string,
) => JSX.Element | false | null | undefined;

export const createProcessingInstructions = (
  processors: HtmlToReactProcessor[],
  language?: string,
): ProcessingInstruction[] => {
  const { processDefaultNode } = ProcessNodeDefinitions();

  return [
    {
      shouldProcessNode: () => true,
      processNode: (node, children, index) => {
        const defaultProcessor = () =>
          processDefaultNode(node, children, index);

        for (const processor of processors) {
          const result = processor(
            node,
            children,
            index,
            defaultProcessor,
            language,
          );
          if (result !== undefined) return result;
        }
        return defaultProcessor();
      },
    },
  ];
};
